import { useState } from "react";
import { Logo } from "../atoms/Logo.jsx";
import { supabase } from "../lib/supabase.js";
import { getApplication, createApplication } from "../services/persona-owner.js";

/**
 * Persona Owner Login — email/password authentication for elected officials.
 */
export function PersonaOwnerLogin({ onSuccess, onSignup, onCancel }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErr("");

    try {
      const { error } = await supabase.auth.signInWithPassword({ email, password });
      if (error) {
        setErr(error.message || "Invalid email or password");
        setLoading(false);
        return;
      }
      onSuccess?.();
    } catch {
      setErr("Login failed \u2014 please try again");
      setLoading(false);
    }
  };

  const handleForgotPassword = async () => {
    if (!email) {
      setErr("Enter your email first");
      return;
    }
    try {
      const { error } = await supabase.auth.resetPasswordForEmail(email);
      if (error) {
        setErr(error.message);
      } else {
        setErr(""); // clear error
        alert("Password reset email sent \u2014 check your inbox.");
      }
    } catch {
      setErr("Failed to send reset email");
    }
  };

  return (
    <div style={{ minHeight: "100vh", background: "#090e1a", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "24px 20px" }}>
      <div style={{ width: "100%", maxWidth: 380 }}>
        <div style={{ textAlign: "center", marginBottom: 36 }}>
          <div style={{ margin: "0 auto 14px", display: "flex", justifyContent: "center" }}><Logo size={32} /></div>
        </div>

        <div style={{ marginBottom: 28 }}>
          <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: "0.15em", color: "#10b981", textTransform: "uppercase", marginBottom: 6 }}>Persona Owner</div>
          <h2 style={{ color: "#f1f5f9", fontSize: 22, fontWeight: 900, fontFamily: "Georgia,serif", margin: 0 }}>Log In to Your Clone</h2>
        </div>

        <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: 14 }}>
          <div>
            <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: "0.1em", color: "#64748b", textTransform: "uppercase", marginBottom: 8 }}>Email</div>
            <input
              autoFocus
              type="email"
              value={email}
              onChange={(e) => { setEmail(e.target.value); setErr(""); }}
              placeholder="you@gov.ng"
              style={{ width: "100%", padding: "13px 16px", background: "#0d1724", border: `1px solid ${err ? "#ef4444" : "#1e2d45"}`, borderRadius: 11, color: "#e2e8f0", fontSize: 15, fontFamily: "inherit", outline: "none", boxSizing: "border-box" }}
            />
          </div>
          <div>
            <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: "0.1em", color: "#64748b", textTransform: "uppercase", marginBottom: 8 }}>Password</div>
            <input
              type="password"
              value={password}
              onChange={(e) => { setPassword(e.target.value); setErr(""); }}
              placeholder="Password"
              style={{ width: "100%", padding: "13px 16px", background: "#0d1724", border: `1px solid ${err ? "#ef4444" : "#1e2d45"}`, borderRadius: 11, color: "#e2e8f0", fontSize: 15, fontFamily: "inherit", outline: "none", boxSizing: "border-box" }}
            />
          </div>

          {err && <div style={{ color: "#ef4444", fontSize: 13 }}>{err}</div>}

          <button type="submit" disabled={loading} style={{ width: "100%", padding: "14px", background: "linear-gradient(135deg, #10b981, #059669)", color: "#fff", border: "none", borderRadius: 11, fontSize: 15, fontWeight: 700, cursor: "pointer", fontFamily: "inherit", marginTop: 4, opacity: loading ? 0.7 : 1 }}>
            {loading ? "Logging in\u2026" : "Login"}
          </button>

          <div style={{ display: "flex", justifyContent: "space-between", fontSize: 13, marginTop: 4 }}>
            <button type="button" onClick={handleForgotPassword} style={{ background: "none", border: "none", color: "#10b981", cursor: "pointer", padding: 0, fontFamily: "inherit" }}>
              Forgot password?
            </button>
            <button type="button" onClick={onSignup} style={{ background: "none", border: "none", color: "#94a3b8", cursor: "pointer", padding: 0, fontFamily: "inherit" }}>
              Create account
            </button>
          </div>

          <button type="button" onClick={onCancel} style={{ width: "100%", padding: "12px", background: "transparent", border: "1px solid #1e2d45", color: "#64748b", borderRadius: 11, fontSize: 14, cursor: "pointer", fontFamily: "inherit", marginTop: 4 }}>
            Back to citizen view
          </button>
        </form>
      </div>
    </div>
  );
}

export default PersonaOwnerLogin;
